import { AccountLinkingScreencastTokenBackendResponse, AccountLinkingScreencastTokenRequest, AccountLinkingScreencastTokenResponse } from "modules/checkout/types/accountLinkingRemoteBrowser";
import apiClient from "modules/main/services/apiClient";
import { accountLinkingScreencastTokenEndpoint } from "modules/main/services/endpoints";

/**
 * Requests a fresh account-linking screencast token for the selected store.
 * @param request Target store request payload.
 * @returns Token payload ready to be passed to the orchestrator remote browser.
 */
export const requestAccountLinkingScreencastToken = async ({
  storeId,
}: AccountLinkingScreencastTokenRequest): Promise<AccountLinkingScreencastTokenResponse> => {
  const response = await apiClient.get<AccountLinkingScreencastTokenBackendResponse>(
    accountLinkingScreencastTokenEndpoint(storeId),
  );

  return {
    token: response.token,
    expiresInSeconds: response.expires_in_seconds,
  };
};
